var React = require('react');
var PropTypes = React.PropTypes;
var ReviewTaskRes = require('../../../resources/review_task');
import ReviewCommentList from './ReviewCommentList';
import RaisedButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
var Auth = require('../../../resources/auth');
import Collapsible from '../../Collapse/Collapsible';
import CollapsibleHeader from '../../Collapse/CollapsibleHeader';
import CollapsibleContent from '../../Collapse/CollapsibleContent';

var COMMON_MISTAKES = [{
  title: 'Answer not defined',
  value: 'Answer not defined'
}, {
  title: 'Title not defined',
  value: 'Title not defined'
}]

var ReviewQuestion = React.createClass({

  // User
  buildUserReviewScore: function(question) {
    var kquestion = question.kquestion;
    var reviewTaskData = this.state.reviewTaskData;
    if (!kquestion.reviewTasks || kquestion.reviewTasks.length === 0) return;
    for (var i = 0; i < kquestion.reviewTasks.length; i++) {
      var task = kquestion.reviewTasks[i];
      if (task.reviewer === Auth.getCurrentUser()._id && task.reviewRound === reviewTaskData.contentInfo.current_review_round) {
        kquestion.userCurrentRoundReviewScore = task.reviewScore;
        break;
      }
    }
  },

  buildCommentsArrayByDateAndRound: function(question) {
    var kquestion = question.kquestion;
    kquestion.reviewComments = [];
    for (var i = 0; i < this.state.reviewTaskData.contentInfo.current_review_round; i++) kquestion.reviewComments.push([]);
    
    if (kquestion.reviewTasks && kquestion.reviewTasks.length > 0) {
      for (var j in kquestion.reviewTasks) {
        var reviewRoundIndex = (kquestion.reviewTasks[j].reviewRound - 1 >= 0) ? kquestion.reviewTasks[j].reviewRound - 1 : 0;
        if (!kquestion.reviewComments[reviewRoundIndex]) kquestion.reviewComments[reviewRoundIndex] = [];
        kquestion.reviewComments[reviewRoundIndex].push(kquestion.reviewTasks[j]);
          if (kquestion.reviewTasks[j].messages && kquestion.reviewTasks[j].messages.length > 0) {
          for (var k in kquestion.reviewTasks[j].messages) {
            kquestion.reviewTasks[j].messages[k].type = 'TASK_MESSAGE';
            kquestion.reviewComments[reviewRoundIndex].push(kquestion.reviewTasks[j].messages[k]);
          }
        }
      }
    }
    // If in some case there is no review tasks (admin review before assigning to any reviewers)
    else {
      var currentRound = this.state.reviewTaskData.contentInfo.current_review_round;
      kquestion.reviewComments[currentRound-1] = [];
    }

    if (kquestion.messages && kquestion.messages.length > 0) {
      for (var k = 0; k < kquestion.messages.length; k++) {
        var message = kquestion.messages[k],
            roundIndex = (message.metadata.reviewRound && message.metadata.reviewRound > 0) ? message.metadata.reviewRound - 1 : 0;
        if (!kquestion.reviewComments[roundIndex]) kquestion.reviewComments[roundIndex] = [];
        kquestion.reviewComments[roundIndex].push(message);
      }
    }
    for (var kk = 0 ; kk < kquestion.reviewComments.length; kk++) {
      if (!kquestion.reviewComments[kk]) continue;
      kquestion.reviewComments[kk].sort(function(a,b) {
        return b.dateModified - a.dateModified;
      })
    }
    console.log('question after build', this.state.question.kquestion)
  },

  buildReviewCommentMapping: function(question) {
    var kquestion = question.kquestion;
    if (!kquestion.reviewMapping) kquestion.reviewMapping = {};
    if (kquestion.reviewTasks && kquestion.reviewTasks.length > 0) {
      for (var j in kquestion.reviewTasks) {
        kquestion.reviewMapping[kquestion.reviewTasks[j]._id] = kquestion.reviewTasks[j];
        if (kquestion.reviewTasks[j].messages && kquestion.reviewTasks[j].messages.length > 0) {
          for (var k in kquestion.reviewTasks[j].messages) {
            kquestion.reviewMapping[kquestion.reviewTasks[j].messages[k]._id] = kquestion.reviewTasks[j].messages[k];
          }
        }
      }
    }
  },

  buildReviewStats: function(question) {
    var kquestion = question.kquestion;
    kquestion.reviewStats = [];
    for (var j in kquestion.reviewComments) {
      var a = 0, n = 0;
      for (var k in kquestion.reviewComments[j]) {
        if (kquestion.reviewComments[j][k].reviewScore === 1) a++;
        else if (kquestion.reviewComments[j][k].reviewScore === 2) n++;
      }
      kquestion.reviewStats[j] = {a: a, n: n};
    }
  },

  retrieveOtherReviewTasks: function(question, callback) {
    if (!question.kquestion || !question.kquestion._id) return;
    var _this = this;
    var kquestion = question.kquestion;
    kquestion.isLoadingOtherReviewTasks = true;
    this.setState({
      question: question
    })

    callback = callback || function(){};
    var query = {
      include: "message",
      conditions: JSON.stringify({
        type: {
          "$in": ["COLLECTION_KQUESTIONS_REVIEW", "COLLECTION_KQUESTIONS_ADMIN_REVIEW"]
        },
        content: this.state.reviewTaskData.contentInfo._id,
        kquestion: kquestion._id
      })
    }
        
    if (this.props.taskMode === 'review') {
      query = {
        include: "message",
        conditions: JSON.stringify({
          type: {
            "$in": ["COLLECTION_KQUESTIONS_REVIEW"]
          },
          content: this.state.reviewTaskData.contentInfo._id,
          kquestion: kquestion._id,
          reviewer: Auth.getCurrentUser()._id
        })
      }
    }
    var options = {query: query};
    ReviewTaskRes.retrieveSingleReviewTask(options, function(err, res) {
      if (res && res.length > 0) kquestion.reviewTasks = res;
      kquestion.isLoadingOtherReviewTasks = false;
      _this.setState({
        question: question
      }, function() {
        return callback(err, res);
      })
    })
  },

  submitMessage: function(round) {
    var _this = this;
    var question = this.state.question;
    var refId = "commentInput-" + round + "-" + question.kquestion._id;
    var text = this.refs[refId].value;
    if (!text.replace(/ /g, '')) return;
    var options = {};
    var mode = this.props.taskMode;
    if (mode === 'review') {
      var reviewTaskId = question.kquestion.reviewTasks[round]._id;
      options = {
        reviewTask: reviewTaskId,
        text: text
      }
    } else if (mode === 'revise' || mode === 'admin-view') {
      options = {
        type: "KQUESTION_MESSAGE",
        text: text,
        kquestion: question.kquestion._id,
        metadata: {
          reviewRound: round+1
        }
      }
    }
    if (!options.text) return;
    ReviewTaskRes.submitMessage(options, function(err, res) {
      question.kquestion.reviewComments[round].push(res);
      _this.refs[refId].value = "";
      // _this.forceUpdate();
      _this.setState({
        question: question
      })
    })
  },

  onReviewQuestionChange: function(round, event, value) {
    var currentUser = Auth.getCurrentUser();
    if (currentUser.role.toLowerCase() === 'admin') {
      this.submitAdminQuestionReview(round, value);
    } else {
      this.submitQuestionReview(round, value);
    }
  },

  submitQuestionReview: function(round, score) {
    var _this = this;
    var question = this.state.question,
        kquestion = question.kquestion;
    // score = parseInt(score);
    var reviewTaskId = this.state.reviewTaskData._id;
    var urlOption = {
      taskId: reviewTaskId,
      questionId: kquestion._id
    }
    var valueOption = {
      "status": "done",
      "reviewScore": score // 1 approve, 2 reject
    }
    ReviewTaskRes.submitQuestionReview(urlOption, valueOption, (err, res) => {
      if (!err && res) {
        Object.assign(kquestion.reviewMapping[res._id], res);
        kquestion.reviewStats[round].a = 0;
        kquestion.reviewStats[round].n = 0;
        for (var i = 0; i < kquestion.reviewTasks.length; i++) {
          var currentRoundIndex = kquestion.reviewTasks[i].reviewRound-1;
          if (currentRoundIndex !== round) continue;
          if (kquestion.reviewTasks[i].reviewScore === 1) kquestion.reviewStats[round].a++;
          else if (kquestion.reviewTasks[i].reviewScore === 2) kquestion.reviewStats[round].n++;
        }
        if (this.props.updateOtherReviewTasks && typeof this.props.updateOtherReviewTasks === 'function') {
          this.props.updateOtherReviewTasks();
        }
        this.setState({
          question: question
        })
      }
    })
  },

  submitAdminQuestionReview: function(round, score) {
    var _this = this;
    var question = this.state.question,
        kquestion = question.kquestion;
    score = parseInt(score);
    var urlOption = {
      collectionId: this.state.reviewTaskData.contentInfo._id,
      questionId: kquestion._id
    }
    var valueOption = {
      reviewRound: round+1,
      // reviewRound: round,
      reviewScore: score
    }
    ReviewTaskRes.submitAdminQuestionReview(urlOption, valueOption, (err, res) => {
      if (!err && res) {
        var adminReviewExists = false;
        for (var i = 0; i < kquestion.reviewComments[round].length; i++) {
          if (kquestion.reviewComments[round][i].type === 'COLLECTION_KQUESTIONS_ADMIN_REVIEW') {
            adminReviewExists = true;
            kquestion.reviewComments[round][i] = res;
          }
        }
        if (!adminReviewExists) {
          kquestion.reviewComments[round].push(res);
          kquestion.reviewTasks.push(res);
          kquestion.reviewMapping[res._id] = res;
        } else {
          Object.assign(kquestion.reviewMapping[res._id], res);
        }
        kquestion.reviewStats[round].a = 0;
        kquestion.reviewStats[round].n = 0;
        for (var i = 0; i < kquestion.reviewTasks.length; i++) {
          var currentRoundIndex = kquestion.reviewTasks[i].reviewRound-1;
          if (currentRoundIndex !== round) continue;
          if (kquestion.reviewTasks[i].reviewScore === 1) kquestion.reviewStats[round].a++;
          else if (kquestion.reviewTasks[i].reviewScore === 2) kquestion.reviewStats[round].n++;
        }
        if (this.props.updateOtherReviewTasks && typeof this.props.updateOtherReviewTasks === 'function') {
          this.props.updateOtherReviewTasks();
        }
        this.setState({
          question: question
        })
      }
    })
  },

  onCommonMistakeChange: function(refId, e) {
    if (this.refs[refId].value) {
      this.refs[refId].value += ", " + e.target.value
    } else {
      this.refs[refId].value += e.target.value;
    }
  },

  getInitialState: function() {
    return {
      reviewTaskData: this.props.reviewTaskData,
      question: this.props.question
    };
  },

  componentWillMount: function() {

  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      reviewTaskData: nextProps.reviewTaskData ? nextProps.reviewTaskData : this.state.reviewTaskData,
      question: nextProps.question ? nextProps.question : this.state.question
    })
  },

  render: function() {
    var _this = this,
        kquestion = this.state.question.kquestion,
        mode = this.props.taskMode,
        isCommentable = (mode === 'review') || (mode === 'revise') || (mode === 'admin-view'),
        isReviewable = (mode === 'review') || (mode === 'admin-view');
    return (
      <div className="review-round">
      {
        kquestion && kquestion.reviewComments && kquestion.reviewComments.length > 0 && kquestion.reviewComments.map(function(data, index1) {
          return (
            <div key={index1} style={{marginBottom: "10px"}}>
              <Collapsible>
                <CollapsibleHeader>
                  <div className="round-title">
                    <span>{"Round " + (index1+1)}</span>
                    <span>(</span>
                    {
                      (kquestion.reviewStats && kquestion.reviewStats[index1]) ?
                      <span className="positive">{"A: " + kquestion.reviewStats[index1].a}</span> : <span className="positive">{"A: -"}</span>
                    }
                    <span> - </span>
                    {
                      (kquestion.reviewStats && kquestion.reviewStats[index1]) ?
                      <span className="negative">{"N: " + kquestion.reviewStats[index1].n}</span> : <span className="negative">{"N: -"}</span>
                    }
                    <span>)</span>
                    <span className="icon closable fa fa-angle-up"></span>
                  </div>
                </CollapsibleHeader>
                <CollapsibleContent>
                  <div>
                    {
                      index1 === kquestion.reviewComments.length-1 && isReviewable && (
                        <div className="text-center" style={{padding: "10px 0", borderBottom: "1px solid #ddd"}}>
                          <RadioButtonGroup
                            name="reviewScore"
                            defaultSelected={kquestion.userCurrentRoundReviewScore}
                            onChange={_this.onReviewQuestionChange.bind(_this, index1)}>
                            <RadioButton
                              style={{display: "inline-block", width: "auto"}}
                              labelStyle={{fontWeight: "500", fontSize: "13px", lineHeight: "20px", width: "auto", color: "#009285"}}
                              iconStyle={{width: "20px", height: "20px", fill: "#009285"}}
                              value={1}
                              label="Approve"
                            />
                            <RadioButton
                              style={{display: "inline-block", width: "auto"}}
                              labelStyle={{fontWeight: "500", fontSize: "13px", lineHeight: "20px", width: "auto", color: "#e2727b"}}
                              iconStyle={{width: "20px", height: "20px", fill: "#e2727b"}}
                              value={2}
                              label="Need Review"
                            />
                          </RadioButtonGroup>
                        </div>
                      )
                    }
                    <ReviewCommentList comments={data} />
                    {
                      index1 === kquestion.reviewComments.length-1 && isCommentable && (
                        <div className="comment-box">
                          <input type="text" className="form-control" placeholder="Write a comment" ref={"commentInput-" + index1 + "-" + kquestion._id}/>
                          <select
                            className="form-control"
                            style={{display: "inline-block", width: "auto"}}
                            onChange={_this.onCommonMistakeChange.bind(_this, ("commentInput-" + index1 + "-" + kquestion._id))} defaultValue={"Common Mistakes"}>
                              <option disabled value="Common Mistakes">Common Mistakes</option>
                              {
                                COMMON_MISTAKES.map(function(mistake, mIndex) {
                                  return <option value={mistake.value} key={mIndex}>{mistake.title}</option>
                                })
                              }
                          </select>
                          <RaisedButton
                            primary={true}
                            label="Comment"
                            onClick={_this.submitMessage.bind(_this, index1)}
                            style={{float: "right"}}
                          />
                        </div>
                      )
                    }
                  </div>
                </CollapsibleContent>
              </Collapsible>
            </div>
          )
        })
      }
      </div>
    );
  },

  componentDidMount: function() {
    var question = this.state.question;
    this.buildCommentsArrayByDateAndRound(question);
    console.log('question in did mount ', question.kquestion)
    console.log('Review task data ', this.state.reviewTaskData)
    
    this.buildUserReviewScore(question);
    this.retrieveOtherReviewTasks(question, (err, res) => {
      this.buildCommentsArrayByDateAndRound(question);
      this.buildUserReviewScore(question);
      this.buildReviewCommentMapping(question);
      this.buildReviewStats(question);
      if (this.props.updateOtherReviewTasks && typeof this.props.updateOtherReviewTasks === 'function') {
        this.props.updateOtherReviewTasks();
      }
      this.setState({
        question: question
      })
    })
  },

});

module.exports = ReviewQuestion;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/Review/ReviewQuestion.js
 **/